import { fromToDateFormatter } from "../../../utils/formatters/dateFormatter";
import MenuDateSelect from "../MenuDateSelect";
import { getUserSelectedDateOption } from "./customDateUtils";

export default function MonthToMonth(props) {
  const {
    dateConfig,
    dateFiltersConfig,
    saveStickyDatesToStore,
    selectedDateType,
    activeTabUuid,
  } = props;

  const userSelected = getUserSelectedDateOption(
    dateFiltersConfig,
    activeTabUuid
  );

  const defaults = fromToDateFormatter(
    dateFiltersConfig.rangeSettingsTerm,
    dateFiltersConfig.rangeSettingsRange
  );

  const { from, to } = userSelected ?? defaults;
  return (
    <MenuDateSelect
      show={true}
      dateFiltersConfig={dateFiltersConfig}
      onChange={dateConfig.onDateChangeHandler}
      startDate={from}
      endDate={to}
      saveStickyDatesToStore={saveStickyDatesToStore}
      selectedDateType={selectedDateType}
    />
  );
}
